import { render, staticRenderFns } from "./InvestmentAccountTypeChange.vue?vue&type=template&id=3acabf4d"
import script from "./InvestmentAccountTypeChange.vue?vue&type=script&lang=ts"
export * from "./InvestmentAccountTypeChange.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports